module.exports = function(app) {
	'use strict';

	app.controller('pages.employee.enrollment', ['$scope', '$state', 'sessionData', 'navigation', 'coremetrics',
		function ($scope, $state, sessionData, navigation, coremetrics) {
			$scope.entitlements = sessionData.entitlements;

			if (!$scope.entitlements.employees.view) {
				return $state.go('home');
			}
            if ((sessionData.entitlements.clientStatus.cancelled == true)
                && (!sessionData.cancelledClientHasAgreed)) {
                $state.go('cancelledConditions');
            }

			$scope.enrollmentTutorialLink = navigation.data.enrollmentTutorial[0];

			$scope.fireCoremetrics = function(cm) {
				if (cm && cm instanceof Object) {
					coremetrics.elementTag(cm.elementId, cm.theCategory);
				}
			};
		}]
	);
};

